import { useNavigate, useParams } from '@tanstack/react-router'

import { useMutationObservers } from '@/shared/lib/useMutationObservers'

import TemplateBuilder from './TemplateBuilder'
import TemplateBuilderProvider from './TemplateBuilderProvider'

export function ScenarioTemplateBuilderPage() {
	const { template_id } = useParams({
		strict: false,
	})
	const navigate = useNavigate()
	useMutationObservers({
		mutationKey: ['settings-templates-delete'],
		onSuccess: () =>
			navigate({
				to: '/p/templates/$template_id',
				params: { template_id: 'scenario' },
			}),
	})

	return (
		<TemplateBuilderProvider templateId={template_id}>
			<TemplateBuilder />
		</TemplateBuilderProvider>
	)
}
